import { normalizeAndRemapTimeline, normalizeAndRemapMarker, normalizeAndRemapTimespan } from '@utils/entities.js'
import { receiveEntities, removeEntity } from '@actions/entity_actions.js'
import { toastSuccess } from '@actions/toast_actions.js'

export function handleCreateMarkerSuccess(response) {
  return dispatch => {
    const normalized = normalizeAndRemapMarker(response.data)
    dispatch(receiveEntities(normalized.entities))
    dispatch(toastSuccess('Created event'))
  }
}

export function handleUpdateMarkerSuccess(id, response) {
  return dispatch => {
    const normalized = normalizeAndRemapMarker(response.data)
    dispatch(receiveEntities(normalized.entities))
    dispatch(toastSuccess('Updated event'))
  }
}

export function handleDeleteMarkerSuccess(id, response) {
  return dispatch => {
    const { id: deletedId, timeline_id: parentId } = response.data
    dispatch(removeEntity(deletedId, 'marker', parentId, 'timeline'))
    dispatch(toastSuccess('Deleted event'))
  }
}

export function handleCreateTimespanSuccess(response) {
  return dispatch => {
    const normalized = normalizeAndRemapTimespan(response.data)
    dispatch(receiveEntities(normalized.entities))
    dispatch(toastSuccess('Created timespan'))
  }
}

export function handleUpdateTimespanSuccess(id, response) {
  return dispatch => {
    const normalized = normalizeAndRemapTimespan(response.data)
    dispatch(receiveEntities(normalized.entities))
    dispatch(toastSuccess('Updated timespan'))
  }
}

export function handleDeleteTimespanSuccess(id, response) {
  return dispatch => {
    const { id: deletedId, timeline_id: parentId } = response.data
    dispatch(removeEntity(deletedId, 'timespan', parentId, 'timeline'))
    dispatch(toastSuccess('Deleted timespan'))
  }
}

export function handleUpdateTimelineSuccess(id, response) {
  return dispatch => {
    const responseData = response.data.data

    // first normalize the timeline node
    let normalized = normalizeAndRemapTimeline(responseData.timeline)
    // then create the entities object we can dispatch, which includes the current user
    const entities = {
      ...normalized.entities,
      current_user: responseData.current_user,
    }
    dispatch(receiveEntities(entities))
    dispatch(toastSuccess('Updated timeline'))
  }
}
